import {
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import "moment/locale/es";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  conveniosTraerCapitulos,
  conveniosPrevisualizacion,
} from "../../../actions/contrataciones/contratacionesConvenios";
import { startAlerta } from "../../../actions/ui/alertas";

export const ConveniosNomencladosSeleccionarPracticas = (props) => {
  const dispatch = useDispatch();

  const { capitulos } = useSelector((state) => state.contratacionesConvenios);

  useEffect(() => {
    dispatch(conveniosTraerCapitulos());
    // eslint-disable-next-line
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();

    const idCapitulosSeleccionados = capitulos
      .filter(
        (capitulo) =>
          e.target.elements[`capitulo-${capitulo.idCapitulo}`].checked
      )
      .map((capitulo) => capitulo.idCapitulo);
    const redondeo = e.target.elements.redondeo.checked;
    props.setearValor("redondeo", redondeo);

    if (
      Object.keys(props.formValues).length > 0 &&
      idCapitulosSeleccionados.length > 0
    ) {
      const preData = {
        ...props.formValues,
        capitulos: idCapitulosSeleccionados,
        redondeo,
      };

      const dataFormateda = {
        ...preData,
        galenoBioquimico: parseFloat(preData.galenoBioquimico),
        galenoConsulta: parseFloat(preData.galenoConsulta),
        galenoEcografico: parseFloat(preData.galenoEcografico),
        galenoPractica: parseFloat(preData.galenoPractica),
        galenoQuirurgico: parseFloat(preData.galenoQuirurgico),
        galenoRadiologico: parseFloat(preData.galenoRadiologico),
        galenoTAC: parseFloat(preData.galenoTAC),
        galenoUTI: parseFloat(preData.galenoUTI),
        gastoBioquimico: parseFloat(preData.gastoBioquimico),
        gastoEcografico: parseFloat(preData.gastoEcografico),
        gastoQuirurgico: parseFloat(preData.gastoQuirurgico),
        gastoRadiologico: parseFloat(preData.gastoRadiologico),
        gastoTAC: parseFloat(preData.gastoTAC),
        gastoUTI: parseFloat(preData.gastoUTI),
        gastoUnidadPension: parseFloat(preData.gastoUnidadPension),
        otrosGastos: parseFloat(preData.otrosGastos),
      };

      dispatch(
        conveniosPrevisualizacion(dataFormateda, props.setShowPrevisualizacion)
      );
    } else if (idCapitulosSeleccionados.length === 0) {
      dispatch(
        startAlerta("Seleccione alguna categoria", "warning", `¡Error!`)
      );
    } else {
      dispatch(startAlerta("Llenar los campos", "warning", `¡Error!`));
    }
  };

  return (
    <form onSubmit={submitHandler}>
      {capitulos?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Ingreso</TableCell>
              <TableCell>Capitulo</TableCell>
              <TableCell>Desde Cod</TableCell>
              <TableCell>Hasta Cod</TableCell>
              <TableCell>Especilidad</TableCell>
              <TableCell>Galeno</TableCell>
              <TableCell>Gasto</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {capitulos.map((capitulo) => {
              return (
                <TableRow key={capitulo.idCapitulo}>
                  <TableCell>
                    <Checkbox name={`capitulo-${capitulo.idCapitulo}`} />
                  </TableCell>
                  <TableCell>{capitulo.capitulo}</TableCell>
                  <TableCell>{capitulo.codigoPracticaDesde}</TableCell>
                  <TableCell>{capitulo.codigoPracticaHasta}</TableCell>
                  <TableCell>{capitulo.especialidad}</TableCell>
                  <TableCell>{capitulo.galeno}</TableCell>
                  <TableCell>{capitulo.gasto}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ margin: "2rem", fontStyle: "italic" }}>
          No hay capitulos
        </Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        style={{ margin: "1.5rem" }}
        onClick={props.closeModalPracticasHandler}
      >
        Cancelar
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{ margin: "1.5rem" }}
        type="submit"
      >
        Siguiente
      </Button>
      <FormControlLabel
        style={{ marginLeft: "1rem" }}
        control={
          <React.Fragment>
            <Checkbox name="redondeo" />
            <Typography>Redondeo</Typography>
          </React.Fragment>
        }
      />
    </form>
  );
};
